import { render, staticRenderFns } from "./ToolbarConfiguration.vue?vue&type=template&id=0be5330a&scoped=true&"
import script from "./ToolbarConfiguration.vue?vue&type=script&lang=js&"
export * from "./ToolbarConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarConfiguration.vue?vue&type=style&index=0&id=0be5330a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5330a",
  null
  
)

export default component.exports